import { Route, Switch, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import HomePage from "./pages/HomePage";
import "./App.css";
import { LanguageContextProvider } from "./hooks/language-context";
import i18next from "i18next";
import HttpApi from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import Header from "./layout/header/Header";
import Footer from "./layout/footer/Footer";

import configureTypesStore from "./hooks/types-store";
import configureSensorsStore from "./hooks/sensors-store";
import DynamicData from "../SMARTCITY/DynamicData/DynamicData";
import MapPage from "./pages/MapPage";
import Map from "./components/Map/Map";
import Charts from "./components/charts/Charts";
import TermsOfUse from "./pages/TermsOfUse";
import Accessibility from "./pages/Accessibility";
import SensorIdProvider from "./hooks/SensorIdProvider";
import ParkingTypeProvider from "./hooks/ParkingTypeProvider";
import RoutesOnScreen from "./pages/RoutesOnScreen";
import Home from "./components/Home/Home";
import AppProviders from "./hooks/AppProviders";
import { activeData } from "./components/Map/utils";

import ReactGA from "react-ga4";
import CookieConsent from "../CookieConsent";
i18next
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "el"],
    fallbackLng: "el",
    debug: false,
    // Options for language detector
    detection: {
      order: ["path", "cookie"],
      caches: ["cookie"],
      cookieMinutes: 7 * 24 * 60 * 60 * 1000, //7 days
    },
    react: { useSuspense: false },
    backend: {
      loadPath: "/assets/locales/{{lng}}/translation.json",
    },
  })
  .catch((error) => console.warn(error));

configureTypesStore();
configureSensorsStore();

const GAID = "G-LP5E950H4Y";

const App = () => {
  const history = useLocation();

  const [enforceGA4, setEnforceGA4] = useState(null);

  const hasCookie = () => document.cookie.includes(`_ga_${GAID.slice(2)}`);

  useEffect(() => {
    if (enforceGA4) {
      ReactGA.send({
        hitType: "pageview",
        page: history.pathname,
        title: "New page view",
      });
    }
    // hasCookie();
  }, [history.pathname, enforceGA4]);

  return (
    <AppProviders features={activeData.states}>
      <LanguageContextProvider>
        {history.pathname !==
          "/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451" &&
          history.pathname !==
            "/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet" && (
            <Header />
          )}
        <main
          style={
            history.pathname ===
              "/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451" ||
            history.pathname ===
              "/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet"
              ? {
                  marginTop: 0,
                  marginBottom: 0,
                  height: "100%",
                }
              : history.pathname === "/routes-on-screen"
              ? {
                  backgroundImage: "unset",
                  backgroundColor: "black",
                  height: "100vh",
                  marginTop: "unset",
                  color: "lightgreen",
                }
              : {}
          }
        >
          <Switch>
            <Route path="/" component={Home} exact />
            <Route path="/map" component={Map} exact />

            <Route
              path="/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451"
              exact
            >
              <Map mapFrame={true} />
            </Route>

            <Route
              path="/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet"
              component={Charts}
              exact
            />
          </Switch>

          {enforceGA4 && ReactGA.initialize(GAID)}
          {!hasCookie() && <CookieConsent setEnforceGA4={setEnforceGA4} />}
        </main>
        {history.pathname !==
          "/map_frame/36rj0ihiet/uvm5ypescz/mmw1uv8cbk/dolwmo2451" &&
          history.pathname !==
            "/stats_frame/dolwmo2451/mmw1uv8cbk/uvm5ypescz/36rj0ihiet" && (
            <Footer />
          )}
      </LanguageContextProvider>
    </AppProviders>
  );
};

export default App;
